import React, { Component } from "react";
import {
    Row,
    Col,
    Input,
    Button,
    Label,
    InputGroup,
    InputGroupButton
} from "reactstrap";
import { CardElement, injectStripe } from "react-stripe-elements";
import SignaturePad from 'react-signature-pad';

import Registry from "../../../Utils/Registry";
import {NotificationManager} from "react-notifications";

class EnterprisePaymentsBaseForm extends Component{
    constructor(props){
        super(props);

        this.typeChanged = this.typeChanged.bind(this);
        this.handleInputUpdate = this.handleInputUpdate.bind(this);
        this.addPaymentMethod = this.addPaymentMethod.bind(this);
        this.addCreditCard = this.addCreditCard.bind(this);
        this.addSEPA = this.addSEPA.bind(this);
        this.uploadRIB = this.uploadRIB.bind(this);

        this.api = Registry.registered("api");
        this.stripe = Registry.registered("stripe");

        this.state = {
            loading: false,
            card_name: "",
            type: "CB",
            bank_field: "",
            IBAN_field: "",
            owner_name_field: "",
            rib_file: null,
            signature_data: null,
            iban: "",
            signatory_first_name: "",
            signatory_last_name: "",
            signatory_email: ""

        };

        this.signaturePad = null;
    }

    typeChanged(e){
        this.setState({type: e.target.value});
    }

    handleInputUpdate(e, key){
        let s = this.state;
        if(s.hasOwnProperty(key))
            s[key] = e.target.value;
        this.setState(s);
    }

    addPaymentMethod(){
        if(!this.state.loading && this.state.type){
            this.setState({loading: true});
            if(this.state.type === "CB")
                this.addCreditCard();
            else if(this.state.type === "SEPA")
                this.addSEPA();
            else{
                this.setState({loading: false}, () => {
                    NotificationManager.error("Type moyen de paiement inconnu");
                });
            }
        }
    }

    addCreditCard(){
        this.setState({loading: true});

        this.props.stripe.createToken().then(
            payload => {
                if(payload.hasOwnProperty("token")){
                    this.api.post("/business/paymentMethods", {
                        card_name: this.state.card_name,
                        token: payload.token.id
                    })
                        .then(() => {
                            this.setState({loading: false}, () => {
                                NotificationManager.success("Carte ajoutée avec succès");
                            });
                            this.props.newPaymentMethodAdded();
                        })
                        .catch(error => {
                            this.setState({loading: false}, () => {
                                NotificationManager.error("Il y a eu une erreur lors de l'ajout de la carte");
                            });
                        })
                }
                else if(payload.hasOwnProperty("error")){
                    this.setState({loading: false}, () => {
                        NotificationManager.error("Il y a une erreur sur les informations de la carte. Merci de les verifier.");
                    });
                }
            }
        );
    }

    addSEPA(){
        if(this.state.card_name === "" || this.state.IBAN_field === "" || this.state.signatory_first_name === "" || this.state.signatory_last_name === "" || this.state.signatory_email === ""){
            this.setState({loading: false}, () => {
                NotificationManager.error("Merci de bien vouloir remplir tous les champs");
            });
        }
        else{
            this.api.post("/business/paymentMethods?type=SEPA", {
                src_name: this.state.card_name,
                iban: this.state.IBAN_field,
                signatory_first_name: this.state.signatory_first_name,
                signatory_last_name: this.state.signatory_last_name,
                signatory_email: this.state.signatory_email
            })
            .then(results => {  
                let iframe_content = results.approval_iframe.content;
                if(results.approval_iframe.encoded)
                    iframe_content = atob(iframe_content);
                this.props.hideForm();
                this.insertIframe(iframe_content);
            })
            .catch(e => {
                this.setState({loading: false});
                NotificationManager.error("Une erreur est survenue lors de l'ajout du moyen de paiement");
             });
        }
    }

    insertIframe = iframe => {
        let target = document.getElementById('root');
        let temp = document.createElement('div');
        temp.innerHTML = iframe;
        while (temp.firstChild) {
            target.appendChild(temp.firstChild);
        }
    };

    uploadRIB(){
        if(this.refs.file_upload.files[0].size <= 2000000){
            this.setState({
                rib_file: this.refs.file_upload.files[0]
            }, () => {
                // Upload files
                let reader = new FileReader();
                reader.readAsDataURL(this.state.rib_file);
                reader.onload = () => {
                    this.setState({rib_data: reader.result});
                };
                reader.onerror = function (error) {
                    NotificationManager.error("Impossible de lire le fichier.");
                };
            });
        }
        else
            NotificationManager.error("Le fichier est trop volumineux. Taille maximum: 2Mo");
    }

    render(){
        return (
            <div>
                { this.props.showTitle ? <h2 className="ty-subtitle">Ajouter un moyen de paiement</h2> : "" }
                <div className={this.props.tyBlock ? "ty-block" : ""}>
                    <Row>
                        <Col md="12">
                            <Label className="bold">
                                Type
                            </Label>
                            <Input value={this.state.type} type="select" className="marg-b-0" onChange={this.typeChanged}>
                                <option value="CB">Carte bancaire</option>
                                <option value="SEPA">Pr&eacute;l&egrave;vement SEPA</option>
                            </Input>
                        </Col>
                    </Row>
                    <Row className="marg-t-15 marg-b-15">
                        <Col md="12">
                            <Label className="bold">
                                D&eacute;signation
                            </Label>
                            <Input type="text" placeholder={"Exemple : " + (this.state.type === "CB" ? "Carte bleue" : "SEPA") + " transports ..."} className="wp-100" value={this.state.card_name} onChange={e => {this.handleInputUpdate(e, "card_name")}} required />
                        </Col>
                    </Row>

                    <div className="border-b-1-gray">
                    </div>

                    <Row className="marg-b-10 pad-t-15">
                        <Col md="12">
                            {this.state.type === "CB" ?
                                <div>
                                    <Label className="bold">Informations carte</Label>
                                    <CardElement />
                                </div>
                                : (this.state.type === "SEPA" ?
                                    <div>
                                        <Row>
                                            <Col sm="6" xs="12">
                                                <Label className="bold">Nom signataire</Label>
                                                <Input type="text" className="wp-100" value={this.state.signatory_last_name} onChange={e => {this.handleInputUpdate(e, "signatory_last_name")}} required />
                                            </Col>
                                            <Col sm="6" xs="12">
                                                <Label className="bold">Prenom signataire</Label>
                                                <Input type="text" className="wp-100" value={this.state.signatory_first_name} onChange={e => {this.handleInputUpdate(e, "signatory_first_name")}} required />
                                            </Col>
                                            { /* <Col sm="6" xs="12">
                                                <Label className="bold">RIB (Max: 2Mo)</Label>
                                                <InputGroup>
                                                    <Input type="text" className="wp-100" placeholder={"PNG, JPG, PDF ..."} value={this.state.rib_file ? this.state.rib_file.name : ""} disabled="disabled" required />
                                                    <InputGroupButton>
                                                        <input type="file" ref="file_upload" style={{display: "none"}} accept="image/*,application/pdf" onChange={this.uploadRIB}/>
                                                        <Button onClick={() => {this.refs.file_upload.click();}}><i className="icon-upload" aria-hidden="true"> </i></Button>
                                                    </InputGroupButton>
                                                </InputGroup>
                                            </Col> */ }
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <Label className="bold">Email signataire</Label>
                                                <Input type="text" className="wp-100" value={this.state.signatory_email} onChange={e => {this.handleInputUpdate(e, "signatory_email")}} required />
                                            </Col>
                                            { /* <Col sm="6" xs="12">
                                                <Label className="bold">RIB (Max: 2Mo)</Label>
                                                <InputGroup>
                                                    <Input type="text" className="wp-100" placeholder={"PNG, JPG, PDF ..."} value={this.state.rib_file ? this.state.rib_file.name : ""} disabled="disabled" required />
                                                    <InputGroupButton>
                                                        <input type="file" ref="file_upload" style={{display: "none"}} accept="image/*,application/pdf" onChange={this.uploadRIB}/>
                                                        <Button onClick={() => {this.refs.file_upload.click();}}><i className="icon-upload" aria-hidden="true"> </i></Button>
                                                    </InputGroupButton>
                                                </InputGroup>
                                            </Col> */ }
                                        </Row>

                                        <Row className="marg-t-15 marg-b-15">
                                            <Col xs="12" lg="12">
                                                <Label className="bold">IBAN</Label>
                                                <Input type="text" className="wp-100" value={this.state.IBAN_field} onChange={e => {this.handleInputUpdate(e, "IBAN_field")}} required />
                                            </Col>
                                        </Row>

                                        {/*<Row className="marg-t-15 marg-b-15">
                                            <Col xs="12" sm="12" lg="12">
                                                <Label className="bold">Signature</Label>
                                                <SignaturePad clearButton={false} ref={ref => {this.signaturePad = ref;}} />
                                                <img className="eraser" src={require("../../../../public/img/erase-text.png")} onClick={() => {this.signaturePad.clear()}}/>
                                            </Col>
                                        </Row>*/}
                                    </div>
                                    : "")}
                        </Col>
                    </Row>
                </div>
                <div className="center marg-t-20">
                    <Button color="primary" className="text-uppercase" onClick={this.addPaymentMethod}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite f-18"> </i>
                                :
                                "Ajouter"
                        }
                    </Button>
                </div>
            </div>
        );
    }
}

EnterprisePaymentsBaseForm.defaultProps = {
    newPaymentMethodAdded: () => {},
    hideForm: () => {},
    showTitle: true,
    tyBlock: true
};

export default injectStripe(EnterprisePaymentsBaseForm);



// WEBPACK FOOTER //
// ./src/components/Enterprise/Payments/BaseForm.js